import React, { useMemo, useState } from 'react';
import ReactWordcloud from 'react-wordcloud';
import RangeSlider from 'react-bootstrap-range-slider'

const MAX_WORDS = 50
const WordCloudSlide: React.FC<{
  words: Record<string, number>;
  ngram: number;
  idx: number;
  activeSlideIdx: number;
  setPhrase: (p: string) => void;
}> = ({ words, idx, ngram, activeSlideIdx, setPhrase }) => {
  const [cutoff, setCutoff] = useState(0)
  const [debouncedCutoff, setDebouncedCutoff] = useState(0)
  const [loading, setLoading] = useState(false)

  const updatedWords = useMemo(() => {
    let arrOfWords: {
      text: string;
      value: number
    }[] = []
    for (const [word, freq] of Object.entries(words)) {
      arrOfWords.push({
        text: word,
        value: +freq
      })
    }
    arrOfWords = arrOfWords.sort((w1, w2) => w2.value - w1.value)
    return arrOfWords.slice(Math.floor(arrOfWords.length * debouncedCutoff)).slice(0, MAX_WORDS)
  }, [debouncedCutoff, words])

  if (idx !== activeSlideIdx) return null

  return (
    <div>
      <div className='text-center mb-2'>
        <h2>Most Frequently Occurring {ngram > 1 ? `${ngram}-` : ''}Word{ngram === 1 ? 's' : ' Groups'}</h2>
        <span>
          <span className='mr-1' style={{ fontSize: '14px' }}>Cut Off</span>
          <br />
          <RangeSlider
            min={0}
            max={0.9}
            step={0.1}
            value={cutoff}
            disabled={loading}
            onChange={(e) => setCutoff(+e.target.value)}
            tooltip="off"
            onMouseUp={() => {
              setDebouncedCutoff(cutoff)
              setLoading(true)
              setTimeout(() => setLoading(false), 500)
            }}
          />
        </span>
      </div>

      <div style={{
        height: ngram === 3 ? '400px' : ngram === 2 ? '300px' : '400px'
      }}>
        <ReactWordcloud
          words={updatedWords}
          maxWords={MAX_WORDS}
          options={{
            fontSizes: [15, 40],
            rotationAngles: [0, 0],
            rotations: 0,
          }}
          callbacks={{
            onWordClick: (word) => {
              setPhrase(word.text)
            }
          }}
        />
      </div>
    </div>
  )
}

export default WordCloudSlide
